import { BrowserRouter } from 'react-router-dom';
import './App.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import RoutePaths from './router/RoutePaths';
import { ContextProvider } from './context/Context';
import I18nProvider from './language/Provider';
import { LOCALES } from './language/LOCALES';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { LOGIN_PATH } from './router/RouteConstants';

function App() {
    const [cookies, removeCookie] = useCookies();

    const clearCookies = () => {
        Object.keys(cookies).forEach((cookie) => {
            removeCookie(cookie, {
                path: '/',
                domain: window.location.hostname,
            });
        });
        window.location.replace(LOGIN_PATH);
    };

    useEffect(() => {
        const onStorage = (event) => {
            if (event.key === 'logout') {
                clearCookies();
            }
        };

        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    return (
        <I18nProvider locale={LOCALES.ENGLISH}>
            <ContextProvider>
                <BrowserRouter>
                    <RoutePaths />
                </BrowserRouter>
            </ContextProvider>
        </I18nProvider>
    );
}

export default App;
